import { useEffect, useRef } from "react";

export type ViewportLayoutEventOptions = {
  windowScroll?: boolean;
  visualViewportScroll?: boolean;
};

export function registerViewportLayoutListeners(
  callback: () => void,
  options: ViewportLayoutEventOptions = {},
): () => void {
  const { windowScroll = true, visualViewportScroll = true } = options;

  window.addEventListener("resize", callback);
  if (windowScroll) {
    window.addEventListener("scroll", callback, true);
  }
  window.visualViewport?.addEventListener("resize", callback);
  if (visualViewportScroll) {
    window.visualViewport?.addEventListener("scroll", callback);
  }

  return () => {
    window.removeEventListener("resize", callback);
    if (windowScroll) {
      window.removeEventListener("scroll", callback, true);
    }
    window.visualViewport?.removeEventListener("resize", callback);
    if (visualViewportScroll) {
      window.visualViewport?.removeEventListener("scroll", callback);
    }
  };
}

export function useViewportLayoutEvents(
  callback: () => void,
  options: ViewportLayoutEventOptions = {},
): void {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => {
    const invoke = (): void => {
      callbackRef.current();
    };
    return registerViewportLayoutListeners(invoke, options);
  }, [options.visualViewportScroll, options.windowScroll]);
}
